import { DefaultEntityAdapter } from './default-entity.adapter';
import { GroupAdapter } from './interfaces/group.adapter';

export class DefaultGroupAdapter<T>
  extends DefaultEntityAdapter<T>
  implements GroupAdapter<T>
{
  constructor(
    idField = 'id',
    labelField = 'label',
    iconField = 'icon',
    protected readonly groupIdField = 'groupId',
    protected readonly groupLabelField = 'groupLabel',
  ) {
    super(idField, labelField, iconField);
  }

  public getGroupId(item: T): unknown {
    return item[this.groupIdField];
  }

  public getGroupLabel(item: T): string {
    return item[this.groupLabelField] ?? '';
  }
}
